import { AfterViewInit, Directive, ViewChild, ViewContainerRef } from '@angular/core';
import { combineLatestWith, map, Observable } from 'rxjs';
import { UIMenuCategoryDto } from 'src/app/shared/interfaces/ui-menu-category-dto.interface';
import { MenuListRepository } from 'src/app/shared/repositories/menu-list.repository';
import { SessionRepository } from 'src/app/shared/repositories/session.repository';
import { SeparateTask } from 'src/app/shared/utils/separate-task';

@Directive()
export abstract class MainPageAbstract implements AfterViewInit {
  @ViewChild('bannerView', { read: ViewContainerRef }) bannerView: ViewContainerRef;

  categories$: Observable<UIMenuCategoryDto[] | null> = this.menuListRepository.menuNavCategories$.pipe(
    combineLatestWith(
      this.sessionRepository.activeLabelFilter$,
      this.sessionRepository.activeAllergenFilter$
    ),
    map(([categories, labelFilter, allergenFilter]) => {
      if (!labelFilter?.length && !allergenFilter?.length) {
        return categories;
      } else {
        return categories?.filter(category =>
          category.items
            .filter(i => !labelFilter?.length ||  i.labels.some(l => labelFilter.includes(l.name)))
            .filter(i =>  !allergenFilter?.length || i.allergens.every(a => !allergenFilter.includes(a.name)))
            .length > 0
        ) ?? null;
      }
    })
  );
  loadingMenuStatus$: Observable<boolean> = this.menuListRepository.loadingMenuStatus$;

  constructor(
    protected menuListRepository: MenuListRepository,
    protected sessionRepository: SessionRepository
  ) { }

  ngAfterViewInit(): void {
    void this.loadBanner();
  }

  @SeparateTask()
  async loadBanner(): Promise<void> {
    this.bannerView.clear();
    const { BannerSliderComponent } = await import('../../blocks/banner-slider/banner-slider.component');
    this.bannerView.createComponent(BannerSliderComponent);
  }
}